import type { CanvasEvent, HoverEvent } from '../CanvasEvent';
import CanvasObject from '../CanvasObject';
import type SurfaceBase from '../SurfaceBase';
import type { LngLat } from '../SurfaceBase';
import VertexObject from '../VertexObject';

export default class DrawTextObject extends CanvasObject {
  pointerVertex: VertexObject;
  onText: (o: LngLat) => void;

  constructor(id: string, surface: SurfaceBase, onText: (p: LngLat) => void) {
    super(id, surface);
    this.pointerVertex = new VertexObject('pointer', this.surface, {
      point: { x: NaN, y: NaN },
      lngLat: { lng: NaN, lat: NaN },
    });
    this.addChild(this.pointerVertex);
    this.onText = onText;
  }

  onSurfaceTap = (e: CanvasEvent) => {
    this.onText(e.lngLat);
    e.stopBubble();
  };

  onPointerMove = (e: HoverEvent) => {
    this.pointerVertex.setCoords(e);
    this.surface.renderAll();
  };

  render(ctx: CanvasRenderingContext2D) {
    // there is nothing to render
  }

  drawHitArea(ctx: OffscreenCanvasRenderingContext2D, color: string): void {
    // no hit area since we're not drawing anything!
  }
}
